import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { CABANAS } from "@/data/cabanas";
import Gallery from "@/components/Gallery";
import { ArrowLeft, ArrowRight, Check } from "lucide-react";

export default function CabanaDetalhes() {
    const { slug } = useParams();
    const nav = useNavigate();
    const cabana = CABANAS.find((c) => c.slug === slug);

    if (!cabana) {
        return (
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
                <h1 className="text-3xl font-bold text-cdb-forest mb-4">Cabana não encontrada</h1>
                <Link to="/cabanas" className="text-cdb-gold font-bold">
                    Voltar para cabanas
                </Link>
            </div>
        );
    }

    return (
        <div className="bg-cdb-cream pb-24">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
                <button
                    onClick={() => nav(-1)}
                    data-testid="back-btn"
                    className="inline-flex items-center gap-2 text-cdb-earth hover:text-cdb-forest font-bold text-sm"
                >
                    <ArrowLeft className="w-4 h-4" /> Voltar
                </button>
            </div>

            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-8">
                        <span className="text-cdb-gold text-sm font-bold uppercase tracking-widest">
                            {cabana.destaque}
                        </span>
                        <h1
                            data-testid="cabana-title"
                            className="text-4xl sm:text-5xl font-bold text-cdb-forest mt-2 mb-8"
                        >
                            {cabana.nome}
                        </h1>

                        <Gallery fotos={cabana.fotos} alt={cabana.nome} />

                        <div className="mt-12">
                            <h2 className="text-2xl sm:text-3xl font-bold text-cdb-forest mb-6">O espaço</h2>
                            <p className="text-cdb-earth mb-6 leading-relaxed">
                                Tudo na cabana foi carinhosamente pensado para atender casais que amam simplicidade,
                                conforto e a privacidade que a natureza oferece.
                            </p>
                            <ul className="grid sm:grid-cols-2 gap-3">
                                {cabana.comodidades.map((c) => (
                                    <li
                                        key={c}
                                        className="flex items-start gap-3 text-cdb-earth bg-white border border-cdb-sand rounded-2xl p-4"
                                    >
                                        <Check className="w-5 h-5 text-cdb-forest mt-0.5 flex-shrink-0" />
                                        <span className="text-sm">{c}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <aside className="lg:col-span-4">
                        <div className="bg-white border border-cdb-sand rounded-3xl p-8 lg:sticky lg:top-24">
                            <p className="text-xs text-cdb-earth/60 uppercase tracking-wider mb-1">
                                Diária a partir de
                            </p>
                            <p className="text-4xl font-bold text-cdb-forest mb-6">
                                R$ {cabana.diaria.toLocaleString("pt-BR")}
                                <span className="text-sm font-normal text-cdb-earth/60"> / noite</span>
                            </p>
                            <div className="space-y-3 mb-6 pb-6 border-b border-cdb-sand">
                                <p className="text-sm text-cdb-earth">
                                    <span className="font-bold">Check-in:</span> a partir das 15:00
                                </p>
                                <p className="text-sm text-cdb-earth">
                                    <span className="font-bold">Check-out:</span> até as 12:00
                                </p>
                                <p className="text-sm text-cdb-earth">
                                    <span className="font-bold">Inclui:</span> café da manhã e jantar
                                </p>
                                <p className="text-sm text-cdb-earth">
                                    <span className="font-bold">Pet:</span> aceito (taxa R$ 200)
                                </p>
                            </div>
                            <Link
                                to={`/reservas?cabana=${cabana.id}`}
                                data-testid="detalhes-reservar-btn"
                                className="inline-flex w-full items-center justify-center gap-2 bg-cdb-gold hover:bg-cdb-goldDark text-white rounded-full px-6 py-4 font-bold transition-all shadow-md hover:shadow-lg"
                            >
                                Solicitar reserva <ArrowRight className="w-4 h-4" />
                            </Link>
                        </div>
                    </aside>
                </div>
            </div>
        </div>
    );
}
